var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe082",
    d: "M15.879,44C13.745,44,12,42.255,12,40.121V15.879C12,13.745,13.745,12,15.879,12h24.242 C42.255,12,44,13.745,44,15.879v24.242C44,42.255,42.255,44,40.121,44H15.879z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M7.5,28.559V11.5 c0-2.2,1.8-4,4-4h25c2.2,0,4,1.8,4,4v1.245"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M40.5,18.617V36.5 c0,2.2-1.8,4-4,4h-25c-2.2,0-4-1.8-4-4v-1.755"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M29.271,32.389c0.629,1.026,1.312,2.009,2.758,2.009c1.215,0,1.853-0.607,1.853-1.446 c0-1.005-0.659-1.362-1.996-1.946l-0.733-0.314c-2.115-0.901-3.522-2.031-3.522-4.418c0-2.199,1.675-3.873,4.294-3.873 c1.864,0,3.204,0.649,4.17,2.348l-2.283,1.466c-0.503-0.901-1.045-1.256-1.887-1.256c-0.859,0-1.403,0.545-1.403,1.256 c0,0.88,0.545,1.236,1.803,1.78l0.733,0.314c2.492,1.067,3.898,2.156,3.898,4.605c0,2.64-2.074,4.086-4.859,4.086 c-2.723,0-4.27-1.373-5.131-3.074L29.271,32.389z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M18.623,32.464c0.466,0.827,1.176,1.462,2.195,1.462c0.975,0,1.537-0.381,1.537-1.864V22.4h3.074 v10.129c0,3.072-1.801,4.471-4.431,4.471c-2.376,0-4.091-1.593-4.79-3.074L18.623,32.464z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.ad2c6a41bd3ca421fbdb7d18efa2674a.svg";
export { ForwardRef as ReactComponent };